
import React, { useEffect, useState } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { sections } from './data/sections';
import { SocialButtons, StoryContainer, PageTitle, SectionLeftText, SectionRightText } from './components'
import logo from './assets/logo.png'
import './App.css';

function App() {
  const [storyData, setStoryData] = useState({
    title: sections[0].title,
    description: sections[0].description,
    img: sections[0].img,
  });

  const [showStory, setShowStory] = useState(false);

  const updateStoryData = (myData) => {
    setStoryData(myData)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  },[showStory])


  return (
    <MDBContainer className="App mainContainer d-flex justify-content-center text-center mb-5">
      <MDBRow id="mainRowContainer" className="shadow-4-strong w-100 d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0">
          <div className={`sections-container ${showStory ? 'inactive' : 'active'}`}>
              <PageTitle logo={logo} />
              {
                sections.map((section, sectionIndex) => {
                  const {id, title, intro, description, img, imgOnLeftSide } = section;

                    return (
                      <div key={id} className="section-container d-flex no-wrapper flex-column px-3 mb-2">

                          {
                            !imgOnLeftSide ? (
                              <SectionLeftText updateStoryData={updateStoryData} title={title} description={description} img={img} intro={intro} setShowStory={setShowStory} />
                            ) : (
                              <SectionRightText updateStoryData={updateStoryData} title={title} description={description} img={img} intro={intro} setShowStory={setShowStory} />
                            )
                          }
                        <div className="divider mt-3 mb-3 d-flex align-self-center"></div>  
                      </div>
                      
                      )
                })
              }
          </div>
          <StoryContainer showStory={showStory} storyData={storyData} setShowStory={setShowStory} />

          <MDBCol className="col-sm-12 d-flex flex-column justify-content-center align-items-center">
              <SocialButtons />
          </MDBCol>
      </MDBRow>
      
    </MDBContainer>
  );
}

export default App;
